import {
  ADD_USER_INFO,
  AuthorizeAction,
  AuthorizeLoyaltyAction,
  AuthorizeVplusAction,
  GET_FCM_TOKEN,
  GET_MSISDN,
  REMOVE_USER_INFO
} from '../constants';

const initialState = {
  authorized: Boolean(localStorage.getItem('authorized')) || false,
  msisdn: localStorage.getItem('mobile') || "",
  FCMToken: "",
};

const initiaVpluslState = {
  authorized: Boolean(localStorage.getItem('vplus_authorized')) || false,
  msisdn: localStorage.getItem('mobile') || "",
  vplus_tokenhoivien: "",
  vplus_tokendev: "",
  vplus_tokenhoivien_esc: "",
  vplus_userInfo: undefined,
  vplus_promoMenu: undefined,
  vplus_isUpdateEmail: false,
};

const initialLoyaltyState = {
  authorized: Boolean(localStorage.getItem("loyalty_authorized")),
  // msisdn: localStorage.getItem('mobile') || "",
  // vplus_tokenhoivien: "",
  // vplus_tokendev: "",
  // vplus_tokenhoivien_esc: "",
  loyalty_userInfo: undefined,
  // vplus_promoMenu: undefined,
  // vplus_isUpdateEmail: false,
};

export function userReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_USER_INFO:
      return {
        ...state,
        ...action.payload
      };
    case REMOVE_USER_INFO:
      return {};

    default:
      return state;
  }
};

export function authorizedReducer(state = initialState, action) {
  switch (action.type) {
    case AuthorizeAction.LOGIN_ACTION:
      return {
        ...state,
        authorized: true
      };

    case AuthorizeAction.LOGOUT_ACTION:
      return {
        ...state,
        authorized: false
      };

    case AuthorizeAction.LOGIN_3G_4G:
      return {
        ...state,
        isLogin3G: true
      };
    case GET_FCM_TOKEN:
      return {
        ...state,
        FCMToken: action.payload,
      };
    case GET_MSISDN:
      return {
        ...state,
        msisdn: action.payload,
      };
    default:
      return state;
  }
}

export function authorizedVplusReducer(state = initiaVpluslState, action) {
  switch (action.type) {
    case AuthorizeVplusAction.LOGIN_VPLUS_ACTION:
      return {
        ...state,
        authorized: true
      };

    case AuthorizeVplusAction.LOGOUT_VPLUS_ACTION:
      return {
        ...state,
        authorized: false
      };
    case AuthorizeVplusAction.VPLUS_TOKEN_HOIVIEN:
      return {
        ...state,
        vplus_tokenhoivien: action.payload,
      };
    case AuthorizeVplusAction.VPLUS_TOKEN_DEV:
      return {
        ...state,
        vplus_tokendev: action.payload,
      };
    case AuthorizeVplusAction.VPLUS_TOKEN_HOIVIEN_ESC:
      return {
        ...state,
        vplus_tokenhoivien_esc: action.payload,
      };
    case AuthorizeVplusAction.VPLUS_USERINFO:
      return {
        ...state,
        vplus_userInfo: action.payload,
      };
    case AuthorizeVplusAction.VPLUS_USERPROMOMENU:
      return {
        ...state,
        vplus_promoMenu: action.payload,
      };
    case GET_MSISDN:
      return {
        ...state,
        msisdn: action.payload,
      };
    case AuthorizeVplusAction.VPLUS_IS_UPDATE_EMAIL:
      return {
        ...state,
        vplus_isUpdateEmail: action.payload,
      };
    default:
      return state;
  }
}

export function authorizedLoyaltyReducer(state = initialLoyaltyState, action) {
  switch (action.type) {
    case AuthorizeLoyaltyAction.LOGIN_LOYALTY_ACTION:
      return {
        ...state,
        authorized: true
      };

    case AuthorizeLoyaltyAction.LOGOUT_LOYALTY_ACTION:
      return {
        ...state,
        authorized: false
      };
    // case AuthorizeVplusAction.VPLUS_TOKEN_HOIVIEN:
    //   return {
    //     ...state,
    //     vplus_tokenhoivien: action.payload,
    //   };
    // case AuthorizeVplusAction.VPLUS_TOKEN_DEV:
    //   return {
    //     ...state,
    //     vplus_tokendev: action.payload,
    //   };
    // case AuthorizeVplusAction.VPLUS_TOKEN_HOIVIEN_ESC:
    //   return {
    //     ...state,
    //     vplus_tokenhoivien_esc: action.payload,
    //   };
    case AuthorizeLoyaltyAction.LOYALTY_USERINFO:
      return {
        ...state,
        loyalty_userInfo: action.payload,
      };
    // case AuthorizeVplusAction.VPLUS_USERPROMOMENU:
    //   return {
    //     ...state,
    //     vplus_promoMenu: action.payload,
    //   };
    // case GET_MSISDN:
    //   return {
    //     ...state,
    //     msisdn: action.payload,
    //   };
    // case AuthorizeVplusAction.VPLUS_IS_UPDATE_EMAIL:
    //   return {
    //     ...state,
    //     vplus_isUpdateEmail: action.payload,
    //   };
    default:
      return state;
  }
}